module.exports = __webpack_public_path__ + "img/appstore.e7ddcc40.png";